/**
 * AppShell — top-level layout wrapper.
 *
 * Renders the AppHeader, the routed page content in a scroll
 * container, and the floating BottomNav. The scroll container has
 * generous bottom padding so content never disappears behind the
 * floating nav capsule.
 */
import { type ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { BottomNav } from './BottomNav';

interface AppShellProps {
  balance: number | string;
  children: ReactNode;
}

export function AppShell({ balance, children }: AppShellProps) {
  return (
    <div className="min-h-dvh flex flex-col">
      <AppHeader balance={balance} />
      <main className="flex-1 pb-[120px] px-4">{children}</main>
      <BottomNav />
    </div>
  );
}
